// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  flex-grow: 1;
  padding: 20px;
  margin-left: 70px;
  margin-top: 40px;
  margin-right: 2px;
  transition: margin-left 0.3s ease-in-out;
  font-family: "Maersk Headline";
}

.content h3 {
  font-weight: normal;
  font-size: 1.6rem;
}

header h3 {
  margin-bottom: 20px;
}

.sidebar.expanded + .content {
  margin-left: 200px;
}

.sidebar.compressed + .content {
  margin-left: 70px;
  margin-right: 0px;
}

.filters-box {
  box-sizing: border-box;
  margin-top: 1px;
  background-color: white;
  padding: 10px;
  padding-bottom: 6px;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #ccc;
  border-radius: 0;
  box-shadow: none;
  width: 100%;
  max-width: 100%;
}

.text-right {
  text-align: right;
}

.main-content {
  background-color: var(--mp-table-header-background-color);
}

.table-spacing {
  margin-top: 0;
  margin-right: 15px;
}

.loading-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999; /* Ensure it appears above other elements */
}

.custom-spinner {
  color: #b8dbef;
}

.table-container {
  box-sizing: border-box;
  margin-top: 16px;
  background-color: white;
  padding: 15px;
  border: 1px solid #ccc;
  max-width: 100%;
}

.table-header {
  font-size: 5rem;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.error-message {
  color: #656464;
  text-align: center;
  margin-top: 150px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ContainerSearchPage/ContainerSearchPage.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,8BAAA;AACJ;;AAGE;EACE,mBAAA;EACA,iBAAA;AAAJ;;AAEE;EACE,mBAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAE;EACE,iBAAA;EACA,iBAAA;AAGJ;;AADE;EACE,sBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAIJ;;AAFE;EACE,iBAAA;AAKJ;;AAHE;EACE,yDAAA;AAMJ;;AAJE;EACE,aAAA;EACA,kBAAA;AAOJ;;AALE;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA,EAAA,2CAAA;AAQJ;;AANE;EACE,cAAA;AASJ;;AAPE;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAUJ;;AARE;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAWJ;;AATC;EACC,cAAA;EACA,kBAAA;EACA,iBAAA;AAYF","sourcesContent":[".content {\n    flex-grow: 1;\n    padding: 20px;\n    margin-left: 70px;\n    margin-top: 40px;\n    margin-right: 2px;\n    transition: margin-left 0.3s ease-in-out;\n    font-family: 'Maersk Headline';\n    \n   \n  }\n  .content h3{\n    font-weight: normal;\n    font-size:1.6rem;\n  }\n  header h3{\n    margin-bottom: 20px;\n}\n.sidebar.expanded + .content{\n    margin-left: 200px;\n  }\n  .sidebar.compressed+.content{\n    margin-left: 70px;\n    margin-right: 0px;\n  }\n  .filters-box {\n    box-sizing: border-box;\n    margin-top: 1px;\n    background-color: white;\n    padding: 10px;\n    padding-bottom: 6px;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 0;\n    box-shadow: none;\n    width: 100%; \n    max-width: 100%; \n}\n  .text-right{\n    text-align: right;\n  }\n  .main-content{\n    background-color: var(--mp-table-header-background-color);\n  }\n  .table-spacing {\n    margin-top: 0; \n    margin-right: 15px;\n  }\n  .loading-spinner {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 9999; /* Ensure it appears above other elements */\n  }\n  .custom-spinner{\n    color: #b8dbef;\n  }\n  .table-container{\n    box-sizing: border-box;\n    margin-top: 16px;\n    background-color: white;\n    padding: 15px;\n    border: 1px solid #ccc;\n    max-width: 100%;\n  }\n  .table-header{\n    font-size: 5rem;\n    font-weight: bold;\n    color: #000;\n    margin-bottom: 10px;\n  }\n .error-message{\n  color: #656464;\n  text-align: center;\n  margin-top: 150px;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
